export enum MultiAccountAccessType {
  UNKNOWN = 'Unknown',
  THIS_ACCOUNT_ONLY = 'ThisAccountOnly',
  ALL_ACCOUNTS_CONNECTED_TO_THIS_CUSTOMER = 'AllAccountsConnectedToThisCustomer',
  PARTNER = 'Partner',
  ENVIRONMENT_ADMINISTRATOR = 'EnvironmentAdministrator',
}
